import FGTSList from '@/views/fgts/FGTSList.vue';
import FGTSConsultRedesign from '@/views/fgts/FGTSConsultRedesign.vue';
import { screen } from '@/router/screenRoutes';

export default [
  // routes
  {
    ...screen('fgts-proposal'),
    component: FGTSList,
  },
  {
    ...screen('fgts-consult'),
    component: FGTSConsultRedesign,
  },
  {
    ...screen('fgts-reserve'),
    component: () => import('@/views/ReservationList.vue'),
  },
  {
    ...screen('fgts-mass-consult'),
    component: () => import('@/views/fgts/FGTSMassConsult.vue'),
  },
  {
    ...screen('fgts-new'),
    component: () => import('@/views/fgts/FGTSNewProposal.vue'),
  },
  {
    ...screen('fgts-mass-consult-historic'),
    component: () => import('@/views/fgts/FGTSMassConsultHistoric.vue'),
  },

  // redirects (legacy)
  {
    path: '/fgts/consulta-por-lote',
    redirect: { name: 'fgts-mass-consult' },
  },
  {
    path: '/fgts/consultar/novo',
    redirect: { name: 'fgts-consult' },
  },
];
